export const getContentClass = () => {
    return 'inline-flex h-[30px] flex-col shadow items-center justify-center rounded-[5px] bg-[hsl(var(--background-tooltip))] px-2.5 border-none'
}

export const getMessageClassNames = () => {
    return 'text-center font-sans text-xs font-bold leading-tight text-slate-600'
}
